module.exports = __webpack_public_path__ + "static/media/proy_esp.4d960105.png";